const globalSettings = {
    theme: 'default',
    sessionExpiration: 36000, // In seconds, 60*60*10 which means 10 h
    dataType: 'pull',
    autoSave: true,
    autoSaveInterval: 5,
    notificationSound: 'off',
    notificationType: 'screenOnly',
    region: 'US',
    showVideo: false,
    functions: '',
    userGuide:
        'https://morningstardirect.morningstar.com/clientcomm/MarketMonitoring.pdf'
};

export default globalSettings;
